export class FeatureValueObject {
  constructor(
    public readonly geometry: { type: string; coordinates: any },
    public readonly properties: Record<string, unknown>,
  ) {}

  static fromRaw(raw: any): FeatureValueObject {
    return new FeatureValueObject(raw?.geometry, raw?.properties ?? {});
  }
}

export class GeoJsonValueObject {
  private readonly raw: any;

  constructor(
    public readonly type: string,
    public readonly features: FeatureValueObject[],
    raw?: any,
  ) {
    this.raw = raw ?? {
      type,
      features: features.map((f) => ({
        type: 'Feature',
        geometry: f.geometry,
        properties: f.properties,
      })),
    };
  }

  /** Devuelve la FeatureCollection GeoJSON completa tal como la entrega el backend. */
  toJson(): any {
    return this.raw;
  }
}
